import { Component, Input, NO_ERRORS_SCHEMA, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AcmicService, MapfreButtonComponent } from '@mapfre-design-library/src/public_api';
import { InfoTooltipComponent } from '../../../../common/info-tooltip/info-tooltip.component';
import { DataLayerService } from '@services/data-layer/data-layer.service';
import { PolicyTooltipService } from '@services/my-insurance/policy-tooltip.service';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MortgageeModalComponent } from '../mortgagee-modal/mortgagee-modal.component';
import { CustomDateFormatPipe } from '@helpers/_pipes/custom-date-format.pipe';

export interface PaymentContext {
  outstandingBalance: any;
  currentMinAmtDue: any;
  paymentDate: any;
  company: string;
}

@Component({
  selector: 'app-bn-payment-actions',
  templateUrl: './bn-payment-actions.component.html',
  styleUrls: ['./bn-payment-actions.component.scss'],
  imports: [TranslatePipe, RouterLink, CommonModule, MapfreButtonComponent, MortgageeModalComponent, CustomDateFormatPipe, CurrencyPipe, InfoTooltipComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BnPaymentActionsComponent implements OnChanges {
  @Input() policy: any;
  @Input() context!: PaymentContext;
  loading = false;

  @ViewChild('minAmtTooltip') minAmtTooltip?: InfoTooltipComponent;

  showMortgageeModal = false;
  isAcmic: boolean;
  outstandingBalance: any = null;
  currentMinAmtDue: any = null;
  paymentDate: any = null;
  company = '';
  isPaidInFullPending = false;

  get isMobile(): boolean {
    return this.policyTooltipService.isMobile;
  }

  constructor(
    private router: Router,
    private dataLayer: DataLayerService,
    private acmicService: AcmicService,
    private policyTooltipService: PolicyTooltipService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['context'] && this.context) {
      this.outstandingBalance = this.context.outstandingBalance ?? null;
      this.currentMinAmtDue = this.context.currentMinAmtDue ?? null;
      this.paymentDate = this.context.paymentDate ?? null;
      this.company = this.context.company ?? '';
      this.checkIfPaidInFull();
    }
  }

  toggleTooltip(event: Event, tooltip: InfoTooltipComponent): void {
    event.stopPropagation();
    tooltip.toggle();
  }

  triggerDatalayer(label: string): void {
    const event = {
      name: 'click_link',
      category: 'remarked content',
      detail: 'manage policy',
      label: label
    };
    if (this.isAcmic) {
      this.dataLayer.pushEvent(event);
    }
  }

  hasMortgagee(): boolean {
    return (
      this.policy?.billingDetails?.[0]?.mortageeFlag === 'Y' &&
      this.policy?.billingDetails?.[0]?.outstandingbalance > 0
    );
  }

  payNow(): void {
    this.router.navigate(['billing-new', this.policy?.policynumber?.policyNumber, 'make-a-payment']);
  }

  openMortgageeModal(): void {
    this.showMortgageeModal = true;
  }

  closeModal(): void {
    this.showMortgageeModal = false;
  }

  private checkIfPaidInFull(){
    if(!this.policy?.pifDiscountInfo || !this.policy?.pifDiscountInfo?.pifEligible) return;
    
    const savingsAmount = (this.policy?.pifDiscountInfo?.nonDiscountedPremium?.theAmount ?? 0) -
                          (this.policy?.pifDiscountInfo?.pifDiscountedPremium?.theAmount ?? 0);

    this.outstandingBalance = (this.policy?.billingDetails?.[0]?.outstandingbalance ?? 0)
                              + (this.policy?.priorYearBalance?.theAmount ?? 0);
    this.isPaidInFullPending = (savingsAmount === this.outstandingBalance) 
                                  && this.policy?.pifDiscountInfo?.pifDiscountApplied === false;
  }
}
